module.exports = __webpack_public_path__ + "static/media/icon-calendar.20001850.svg";